module.exports = __webpack_public_path__ + "img/bg_dfod.f3c3f495.png";